import { AssetStatusUpsertModel } from './bulk-add-asset-status.model';

export class AssetStatusUpsertArrayModel {
  upsertArray: AssetStatusUpsertModel[];
}
